import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { DEFAULT_LNB_COLLAPSED, SB_HOST_QUERY_KEY } from '@kc-console/guard';

import { setLnbCollapsedSessionCookie } from '../lib/lnbCollapsedSessionCookie';
import { useLnbCollapsedQuery } from './useLnbCollapsedQuery';

/**
 * LNB 접힘/펼침 상태처리 훅
 */
export const useDefaultLayout = () => {
  const queryClient = useQueryClient();
  const { data } = useLnbCollapsedQuery();

  const collapsed = data ?? DEFAULT_LNB_COLLAPSED;

  const toggleCollapsed = useCallback(() => {
    queryClient.setQueryData([SB_HOST_QUERY_KEY.GET_LNB_COLLAPSED], (prev: boolean | undefined) => {
      const next = !(prev ?? DEFAULT_LNB_COLLAPSED);
      setLnbCollapsedSessionCookie(next);
      return next;
    });
  }, [queryClient]);

  return {
    collapsed,
    toggleCollapsed,
  };
};
